// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { focusedItemText, headerText, itemText, linkStyles } from "@conklin/App/SharedStyles/AutoCompleteSharedStyles";
import { autocompleteContentStyles } from "@conklin/Overrides/Widgets/Header/AutocompleteContent";
import { color, mergeWithCss } from "@conklin/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

autocompleteContentStyles.headerText = {
    ...mergeWithCss(headerText, {
        css: css`
            margin: 4px 0 8px 0;
        `,
    }),
};

autocompleteContentStyles.link = {
    ...mergeWithCss(
        { ...linkStyles, typographyProps: itemText },
        {
            css: css`
                ${TypographyStyle} {
                    color: ${color("text")};
                }

                &:hover {
                    ${TypographyStyle} {
                        color: ${color("common.ui10")};
                    }
                }
            `,
        },
    ),
};
autocompleteContentStyles.focusedLink = {
    ...mergeWithCss(
        { ...linkStyles, typographyProps: focusedItemText },
        {
            css: css`
                ${TypographyStyle} {
                    color: ${color("text")};
                }

                &:hover {
                    ${TypographyStyle} {
                        color: ${color("common.ui10")};
                    }
                }
            `,
        },
    ),
};
